import { render, staticRenderFns } from "./ModelDelete.vue?vue&type=template&id=24bf10a5"
import script from "./ModelDelete.vue?vue&type=script&lang=js"
export * from "./ModelDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports